import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
var LayerAnimateStylePlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function LayerAnimateStylePlugin() {
    _classCallCheck(this, LayerAnimateStylePlugin);
  }

  _createClass(LayerAnimateStylePlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.beforeRender.tap('LayerAnimateStylePlugin', function () {
        // @ts-ignore
        var animateStatus = layer.animateStatus;

        if (animateStatus) {
          layer.models.forEach(function (model) {
            model.addUniforms(_objectSpread({}, layer.layerModel.getAnimateUniforms()));
          });
        }
      });
    }
  }]);

  return LayerAnimateStylePlugin;
}()) || _class);
export { LayerAnimateStylePlugin as default };